import React from "react";
import Store from "../../content/Store";
import contentify from "../../content/Contentify";

export class Manifest extends React.Component {
  static content = Store.Manifest;

  linkRef = React.createRef();

  componentDidMount() {
    this.attachManifest.apply(this);
  }

  componentDidUpdate() {
    this.attachManifest.apply(this);
  }

  attachManifest() {
    let manifest = new Blob([JSON.stringify(this.props.content.Manifest)], {
      type: "application/manifest+json"
    });
    this.url = URL.createObjectURL(manifest);

    document
      .querySelector("link[rel='manifest']")
      .setAttribute("href", this.url);
    document
      .querySelector("link[rel='shortcut icon']")
      .setAttribute("href", this.props.content.Favicon);
  }

  componentWillUnmount() {
    this.url && URL.revokeObjectURL(this.url);
  }

  render() {
    return null;
  }
}

export default contentify(Manifest);
